import './scss/index.scss';
import { dcFactory } from 'dc';
import TimelineDecadeComponent from './js/timeline-decade.component';

dcFactory.register(TimelineDecadeComponent);
